// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__2b0jR","rootSmall":"AddTileButton_rootSmall__vAeQm"};